import { useState } from 'react';
import { C } from '../tokens';

// Поле города с подсказками: при вводе показывает список подходящих городов
// (Россия, СНГ и крупные мировые). Список — только помощь, свободный ввод
// любого города остаётся допустимым.

export const CITIES = [
  // Россия — миллионники и крупные
  'Москва', 'Санкт-Петербург', 'Новосибирск', 'Екатеринбург', 'Казань',
  'Нижний Новгород', 'Челябинск', 'Красноярск', 'Самара', 'Уфа',
  'Ростов-на-Дону', 'Краснодар', 'Омск', 'Воронеж', 'Пермь', 'Волгоград',
  'Саратов', 'Тюмень', 'Тольятти', 'Махачкала', 'Барнаул', 'Ижевск',
  'Хабаровск', 'Ульяновск', 'Иркутск', 'Владивосток', 'Ярославль',
  'Кемерово', 'Томск', 'Набережные Челны', 'Ставрополь', 'Оренбург',
  'Новокузнецк', 'Рязань', 'Балашиха', 'Пенза', 'Чебоксары', 'Липецк',
  'Калининград', 'Астрахань', 'Тула', 'Киров', 'Сочи', 'Курск',
  'Улан-Удэ', 'Сургут', 'Тверь', 'Магнитогорск', 'Якутск', 'Брянск',
  'Иваново', 'Владимир', 'Симферополь', 'Белгород', 'Нижний Тагил',
  'Архангельск', 'Калуга', 'Чита', 'Севастополь', 'Грозный', 'Смоленск',
  'Волжский', 'Курган', 'Орёл', 'Череповец', 'Владикавказ', 'Вологда',
  'Мурманск', 'Саранск', 'Тамбов', 'Стерлитамак', 'Петрозаводск',
  'Кострома', 'Нижневартовск', 'Йошкар-Ола', 'Новороссийск', 'Комсомольск-на-Амуре',
  'Таганрог', 'Сыктывкар', 'Нальчик', 'Шахты', 'Дзержинск', 'Братск',
  'Орск', 'Ангарск', 'Благовещенск', 'Псков', 'Бийск', 'Энгельс',
  'Рыбинск', 'Южно-Сахалинск', 'Абакан', 'Норильск', 'Великий Новгород',
  'Петропавловск-Камчатский', 'Люберцы', 'Подольск', 'Химки', 'Мытищи',
  'Королёв', 'Красногорск', 'Одинцово', 'Домодедово', 'Щёлково', 'Реутов',
  'Пятигорск', 'Кисловодск', 'Ессентуки', 'Анапа', 'Геленджик', 'Армавир',
  'Майкоп', 'Черкесск', 'Элиста', 'Магадан', 'Салехард', 'Ханты-Мансийск',
  'Новый Уренгой', 'Нефтеюганск', 'Альметьевск', 'Нижнекамск', 'Зеленодольск',
  'Обнинск', 'Серпухов', 'Коломна', 'Жуковский', 'Раменское', 'Сергиев Посад',
  // Казахстан
  'Алматы', 'Астана', 'Шымкент', 'Караганда', 'Актобе', 'Тараз',
  'Павлодар', 'Усть-Каменогорск', 'Семей', 'Атырау', 'Костанай',
  'Кызылорда', 'Уральск', 'Петропавловск', 'Актау', 'Темиртау', 'Туркестан',
  // Беларусь
  'Минск', 'Гомель', 'Могилёв', 'Витебск', 'Гродно', 'Брест', 'Бобруйск', 'Барановичи',
  // Украина
  'Киев', 'Харьков', 'Одесса', 'Днепр', 'Донецк', 'Запорожье', 'Львов',
  'Кривой Рог', 'Николаев', 'Мариуполь', 'Луганск', 'Винница', 'Херсон',
  'Полтава', 'Чернигов', 'Черкассы', 'Житомир', 'Сумы', 'Ровно', 'Ивано-Франковск',
  // Узбекистан
  'Ташкент', 'Самарканд', 'Бухара', 'Наманган', 'Андижан', 'Фергана', 'Нукус', 'Хива',
  // Кыргызстан
  'Бишкек', 'Ош', 'Джалал-Абад', 'Каракол',
  // Таджикистан
  'Душанбе', 'Худжанд', 'Куляб',
  // Туркменистан
  'Ашхабад', 'Туркменабат', 'Мары',
  // Армения
  'Ереван', 'Гюмри', 'Ванадзор',
  // Азербайджан
  'Баку', 'Гянджа', 'Сумгаит',
  // Грузия
  'Тбилиси', 'Батуми', 'Кутаиси',
  // Молдова
  'Кишинёв', 'Тирасполь', 'Бельцы',
  // Прибалтика
  'Рига', 'Вильнюс', 'Таллин', 'Каунас', 'Даугавпилс',
  // Крупные мировые
  'Берлин', 'Мюнхен', 'Гамбург', 'Франкфурт', 'Париж', 'Лондон', 'Рим',
  'Милан', 'Мадрид', 'Барселона', 'Прага', 'Варшава', 'Краков', 'Вена',
  'Амстердам', 'Брюссель', 'Стокгольм', 'Хельсинки', 'Осло', 'Копенгаген',
  'Лиссабон', 'Афины', 'Стамбул', 'Анталья', 'Анкара', 'Белград', 'София',
  'Бухарест', 'Будапешт', 'Дубай', 'Абу-Даби', 'Тель-Авив', 'Иерусалим',
  'Нью-Йорк', 'Лос-Анджелес', 'Чикаго', 'Майами', 'Торонто', 'Ванкувер',
  'Пекин', 'Шанхай', 'Токио', 'Сеул', 'Бангкок', 'Сингапур', 'Дели', 'Мумбаи',
  'Сидней', 'Мельбурн', 'Каир', 'Буэнос-Айрес', 'Сан-Паулу', 'Мехико',
];

export const suggest = (query) => {
  const q = query.trim().toLowerCase();
  if (q.length < 1) return [];
  const starts = [];
  const contains = [];
  for (const c of CITIES) {
    const lc = c.toLowerCase();
    if (lc === q) continue; // уже введён точно — подсказка не нужна
    if (lc.startsWith(q)) starts.push(c);
    else if (lc.includes(q)) contains.push(c);
  }
  return [...starts, ...contains].slice(0, 6);
};

export default function CityField({ value, onChange, placeholder = 'Москва', style: sx = {} }) {
  const [open, setOpen] = useState(false);
  const items = open ? suggest(value || '') : [];

  return (
    <div style={{ position: 'relative', ...sx }}>
      <input
        value={value}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        placeholder={placeholder}
        autoComplete="off"
        style={{
          display: 'block', width: '100%',
          padding: '13px 16px', borderRadius: 13,
          border: `1.5px solid ${C.border}`,
          fontSize: 16, outline: 'none', boxSizing: 'border-box',
          background: C.white, fontFamily: 'inherit', color: C.dark,
        }}
      />
      {items.length > 0 && (
        // onMouseDown с preventDefault — чтобы клик по подсказке не увёл фокус
        // с инпута раньше, чем сработает выбор (blur закрыл бы список).
        <div
          onMouseDown={(e) => e.preventDefault()}
          style={{
            position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0,
            background: C.white, border: `1.5px solid ${C.border}`,
            borderRadius: 13, overflow: 'hidden', zIndex: 30,
            boxShadow: '0 8px 24px rgba(26,32,48,0.12)',
          }}>
          {items.map((c) => (
            <div key={c}
              onClick={() => { onChange(c); setOpen(false); }}
              className="press"
              style={{
                padding: '11px 16px', fontSize: 15, color: C.dark,
                cursor: 'pointer', borderBottom: `1px solid ${C.bg}`,
              }}>
              📍 {c}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
